module.exports = __webpack_public_path__ + "img/mgh-kyobashi-sp.0daf25b5.jpg";